import React, {useEffect, useState} from 'react'
import Form from '../../../Forms/EnterForm'
import classes from './docotorForm.module.scss'
import {useDispatch, useSelector} from 'react-redux'
import {CardClean, CISHCreation, ExpressCreation, GistologyCreation, IGHCreation} from '../../../../store/reducers/DoctorReducer/DoctorReducer'
import {DoctorService} from '../../../../api/DoctorService'
import {toast} from 'react-toastify'
import Signature from '../../../Signature';
import { useNavigate } from 'react-router-dom'


const DoctorForm = ({type, formFinished}) => {
    const dispatch = useDispatch()
    const values = useSelector(state => state.docForm)
    const changeType = useSelector(state=>state.RegScan.ScanInputs.type) 
    const navigate = useNavigate()

    const [form, setForm] = useState();
    const [renderForm, setRenderForm] = useState(false);
    const [sign, setSign] = useState(false)
    const [endFlow, SetEndFlow] = useState(false)
    const [signId, setSignId] = useState()

    const closeSign = () => {
        setSign(false)
    }

    const [doctorCard, setDoctorCard] = useState({
        "doc": '',
        "data": {
            "color": '',
            "description": '',
            "conclusion": '',
            "archive": '',
            "sign": {},
            "difficultyLevel": '',
            "table": {}
        }
    })

    const handleDoctor = (data) => {
        setDoctorCard({
            "doc": data.doc.id,
            "data": {
                "color": data.color,
                "description": data.description,
                "conclusion": data.conclusion,
                "archive": data.archive,
                "sign": data.sign,
                "difficultyLevel": data.level || '',
                "table": data.table
            }
        })
    }

    const finishFlow = () => {
        SetEndFlow(true)
    }

    const getOptions = () => {
        value.fields.map(async(element) => {
            if (element.legend == 'Лікар'){
                const res = await DoctorService.getAllWorkersByRole()
                if (res?.data){
                    res?.data.doctor.map(docs => {
                        let obj = {
                            "value": docs.name,
                            "label": docs.name,
                            "id": docs.id,
                            "type": 'option'
                        }
                        props.push(obj)
                    })
                }
            }
        })
    }

    let value = '1'
    let props = []

    values.map(el => {
        if (el.formType === type.research){
            value = el
        }
    })

    const showResults = (id) => {
        setSign(true)
        setSignId(id)
    }

    useEffect(() => {
        if (value !== '1'){
            getOptions()
            setForm(value)
            setForm(state => ({
                ...state,
                fields: state?.fields?.map((item) => {
                    let option;
                    if (item.name == 'doc'){
                        option = props;
                    }

                    return option
                        ? {
                            ...item,
                            props: option
                        }
                        : {...item};
                })
            }))
            setRenderForm(true)
        }
    }, [value])

    const DoctorResult = async(id, data) => {
        await DoctorService.updateDocForm(id, data).then(res => {
            if (res) toast.done('Заключення сформовано')
        })

        if (id){
            showResults(id)
        }
    }

    const updateResults = async(id,data)=>{
        await DoctorService.updateFinishedDocForm(id,data.data).then(res => {
            if (res) {
                SetEndFlow(true)
            }
                
        })

    }

    const UpdateStatus = async(id) => {
        await DoctorService.updateStatusDirection(id, {"status":'finished'}).then(res=>{
            if(res) toast.info('Дослідження завершено')
        })
    }

    useEffect(() => {
        if (doctorCard.data.description !== ''){
            if (type.research == 'CISH'){
                dispatch(CISHCreation({credential: doctorCard}))
            } else if (type.research == 'ІГХ'){
                dispatch(IGHCreation({credential: doctorCard}))
            } else if (type.research == 'Гістологія'){
                dispatch(GistologyCreation({credential: doctorCard}))
            } else if (type.research == 'Експрес'){
                dispatch(ExpressCreation({credential: doctorCard}))
            }
            if (changeType === 'change'){
                updateResults(type.id, doctorCard)
            } else{
            DoctorResult(type.id, doctorCard)
            }
            if (endFlow && changeType !== 'change'){
                dispatch(CardClean())
                formFinished(false)
                setRenderForm(false)
                UpdateStatus(type.id)
            } else if (endFlow && changeType === 'change'){
                dispatch(CardClean())
                formFinished(false)
                setRenderForm(false)
                toast.info('Заключення змінено')
                navigate('/Home')
            }
        }
    }, [doctorCard, endFlow])

    return (
        <div className={classes.doctorForm}>
            {renderForm && <Form onChange={handleDoctor} values={form} id={type.id}/>}
            {sign && <Signature id={signId} signed={finishFlow} onSign={closeSign}/>}
        </div>
    )
}

export default DoctorForm